import {Button, Container, Form} from "react-bootstrap";
import Password from "../components/Password";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {useHistory, useLocation} from "react-router-dom";
import React, {useContext, useState} from "react";
import MiniLoader from "../components/MiniLoader";
import axios from "axios";
import AuthContext from "../contexts/AuthContext";

const RecoveryPassword = () => {
    const { t } = useTranslation();
    document.title=t("Create a user password")
    const history = useHistory();
    const myParam = useLocation().search;
    let { loginUser } = useContext(AuthContext)
    const [loader, setLoader] = useState(false)

    let newPassword = async (e) => {
        e.preventDefault()
        let passwordValidation = localStorage.getItem('newPasswordValidation')
        localStorage.removeItem('newPasswordValidation')

        const token = new URLSearchParams(myParam).get("token");

        if (passwordValidation === "true") {
            if (!token) {
                history.push('/verify-email');
                toast(t("The security code has expired"), {type: "error"})
            } else {
                setLoader(true)
                try {
                    let response = await axios.post('/api/v1.0/users/recovery-password/', {
                        'token': token,
                        'password': e.target.password.value,
                        'confirm_password': e.target.confirm_password.value,
                    })

                    e.target.email.value = response.data['email']
                    if(e.target.email.value) {
                        loginUser(e)
                        toast(t("Password created"), {type: "success"})
                    }
                    else {
                        history.push('/login')
                        toast(t("Password created. Now you can log in"), {type: "success"})
                    }
                }
                catch (error) {
                    if (error.response.status === 500) {
                        history.push('/500')
                    }
                    history.push('/login')
                    toast(t("You have already used this link and created a password. You can now log in"), {type: "warning"})
                }
                finally {
                    setTimeout(() => {setLoader(false)}, 200)
                }
            }
        }
    }

    return (
        <Container className="page sign-up-shadow">
            <div className="sign-up-grid">
                <div className="sign-up">
                    <h2>{t("Create a")} <span className="color">{t("New Password")}</span></h2>
                    { !loader
                        ? (
                            <Form onSubmit={newPassword}>
                                <Form.Control className="hide" name="email" />
                                <Password/>
                                <Button variant="green" type="submit">
                                    {t("Create")}
                                </Button>
                            </Form>)
                        : (
                            <div className="center-block">
                                <MiniLoader />
                            </div>
                        )}
                </div>
                {/*<div className="sign-up-img">*/}
                {/*    <img src={require(`../images/pages/start.svg`).default}/>*/}
                {/*</div>*/}
            </div>
        </Container>
    )
}

export default RecoveryPassword
